module.exports = __webpack_public_path__ + "static/media/21.47d286a4.jpg";